import React, { forwardRef, useRef } from 'react';

export function formatRequestPhone(value) {
  const digits = String(value || '').replace(/\D/g, '');
  const prefix = digits.startsWith('02') ? 2 : digits.startsWith('050') && digits.length >= 12 ? 4 : 3;
  if (digits.length <= prefix) return digits;
  const middle = digits.length > prefix + 7 ? 4 : 3;
  if (digits.length <= prefix + middle) return `${digits.slice(0, prefix)}-${digits.slice(prefix)}`;
  return `${digits.slice(0, prefix)}-${digits.slice(prefix, prefix + middle)}-${digits.slice(prefix + middle)}`;
}

export function isValidRequestPhone(value) {
  return /^(?:010\d{8}|01[16789]\d{7,8}|02\d{7,8}|0(?:3[1-3]|4[1-4]|5[1-5]|6[1-4])\d{7,8}|070\d{8}|080\d{7}|050\d{8,9})$/.test(String(value || '').replace(/\D/g, ''));
}

export function hasUsableRequestAttachment(file) {
  const url = file?.dataUrl || file?.previewUrl || file?.url || '';
  return Boolean(file?.name && Number(file?.size) > 0 && /^data:[^,]*;base64,[a-z0-9+/]+={0,2}$/i.test(url));
}

const RequestPhoneInput = forwardRef(function RequestPhoneInput({ style, disabled }, forwardedRef) {
  const input = useRef(null);
  const apply = (node, raw, digitsBeforeCaret) => {
    node.value = formatRequestPhone(raw);
    let cursor = 0;
    let count = 0;
    while (cursor < node.value.length && count < digitsBeforeCaret) {
      if (/\d/.test(node.value[cursor])) count++;
      cursor++;
    }
    node.setSelectionRange(cursor, cursor);
  };
  return <input
    ref={node => { input.current = node; if (typeof forwardedRef === 'function') forwardedRef(node); else if (forwardedRef) forwardedRef.current = node; }}
    type="tel" inputMode="tel" placeholder="010-1234-5678" aria-label="고객 연락처"
    disabled={disabled} style={{ ...style, fontSize: Math.max(16, Number(style?.fontSize) || 16) }}
    onChange={event => { const node = event.target; apply(node, node.value, node.value.slice(0, node.selectionStart).replace(/\D/g, '').length); }}
    onKeyDown={event => {
      const node = input.current;
      const caret = node.selectionStart;
      if (caret !== node.selectionEnd) return;
      // Deleting a separator also deletes the adjacent digit, so formatting cannot trap the caret.
      if (event.key === 'Backspace' && node.value[caret - 1] === '-') {
        event.preventDefault();
        const start = Math.max(0, caret - 2);
        apply(node, node.value.slice(0, start) + node.value.slice(caret), node.value.slice(0, start).replace(/\D/g, '').length);
      } else if (event.key === 'Delete' && node.value[caret] === '-') {
        event.preventDefault();
        apply(node, node.value.slice(0, caret) + node.value.slice(caret + 2), node.value.slice(0, caret).replace(/\D/g, '').length);
      }
    }}
  />;
});
export default RequestPhoneInput;
